import React from "react";
import Navbar from "../components/Navbar";
import HeroSection from "../components/Hero";
import Feature from "../components/Feature";
import StepBox from "../components/StepBox";
import BgService from "../assets/img/bg/bg-service.jpg";
import Dispatch from "../assets/img/icon/dispatch-note.png";
import DeliveryTruck from "../assets/img/icon/delivery-truck.png";
import WawyArrow from "../assets/img/shape/wavy-arrow-1.png";
import WawyArrow0 from "../assets/img/shape/wavy-arrow-2.png";
import Shape from "../assets/img/shape/Shape.png";
import CPClick from "../assets/img/icon/icon-service-2-clr.png";
import Companies from "../components/Companies";
import EmailService from "../components/Email";

function Home() {
  return (
    <div id="bdy">
      <Navbar />
      <HeroSection />
      <Feature />
      <div
        className="step-area de-padding"
        style={{ backgroundImage: `url(${BgService})` }}
      >
        <div className="container">
          <div className="row">
            <div className="col-xl-8 offset-xl-2">
              <div className="site-title text-center">
                <span className="hero-sub-title mb-20">
                  <span className="hero-line"></span>
                  How it works
                </span>
                <h2 className="heading-1" style={{ color: "#FFF" }}>
                  We follow a great process
                </h2>
                <p className="mb-0" style={{ color: "#FFF" }}>
                  Book your next cargo in 3 easy steps
                </p>
              </div>
            </div>
          </div>
          <div className="step-wpr grid-3">
            <StepBox
              icon={Shape}
              noteIcon={DeliveryTruck}
              stepNum="01"
              heading="Choose Destination for Cargo Delivery"
              wavyArrow={WawyArrow0}
            />
            <StepBox
              icon={Shape}
              noteIcon={CPClick}
              stepNum="02"
              heading="Provide Cargo Details and Documentation"
              wavyArrow={WawyArrow}
            />

            <StepBox
              icon={Shape}
              noteIcon={Dispatch}
              stepNum="03"
              heading="Schedule Cargo Pickup and Delivery"
            />
          </div>
        </div>
      </div>
      <Companies />
      <EmailService />
      <a href="#bdy" id="scrtop" class="smooth-menu">
        <i class="ti-arrow-up"></i>
      </a>
    </div>
  );
}

export default Home;
